import MerchantEvaluationExportEntryPdfApi from '@/api/merchant-evaluation-export-entry-pdf'

const state = {}

const mutations = {}

const actions = {
  async listTasks (ctx, params) {
    return MerchantEvaluationExportEntryPdfApi.listTasks(params)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/merchant-evaluation-export-entry-pdf.js